import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn } from "@angular/router";
import { HelpersService } from "../helpers-service/helpers.service";

export const dashboardIdGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
    const helperService = inject(HelpersService);

    if (!helperService.userDataMerged) {
        await helperService.mergeUserData();
    }
    return await helperService.changeDashboard(route.params.dashboardId, true);
};
